<ng-container *transloco="let t">
  <footer class="container-fluid">
    <div class="container py-3">
      <div class="row">
        <div class="col">
          <img src="assets/icons/tracey-alt-logo.svg" alt="Tracey logo"
               [style.height]="'62px'">
        </div>
        <div class="col">
          <div class="d-flex justify-content-end align-items-center h-100">
            <p class="full-screen-copyright small light pe-2 d-inline">{{
                'Copyright © Byteink 2025.'
              }}</p>
            <a href="https://www.byteink.hr/" target="_blank" rel="noopener noreferrer">
              <img src="assets/img/svg/byteink_footer.svg" alt="ByteInk">
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</ng-container>


